export const DefaultCampaignId = 'Aampe';

export const AampeEndPointValue = 'Aampe endpoint';
